import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500; // 개발자가 수동으로 계산한 높이
const MAX_FAIL_COUNT = 10;

function OwnerAuthenticationFailureBottomSheetPage() {
  const {t} = useInferableTranslation();
  /**
   * [2025-09-22:Jeyoung Lee]
   * pageList에서 넘어오기 위한 용도 (searchParams)
   */
  const birthDay = (window as any).data?.birthDay as string;
  const licensePlateNumber = (window as any).data?.licensePlateNumber as string;
  const authFailCount = (window as any).data?.authFailCount as number;
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <div className="bottom_sheet">
        <div className="bottom_sheet_header">
          <h2
            id="bottomSheetTitle"
            className="bottom_sheet_title"
          >
            {t('T30518')}
          </h2>
          <button
            type="button"
            className="btn btn_ic"
            aria-label="close"
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            />
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <strong className="bottom_sheet_title_sub">{t('T30519')}</strong>

            <div className="bottom_sheet_container">
              <dl className="vehicle_info">
                <div className="vehicle_item">
                  <dt className="info_title">{t('T30496')}</dt>
                  <dd className="info_text">{CldrDatetimeFormatter.format(new Date(birthDay), 'full')}</dd>
                </div>
                <div className="vehicle_item">
                  <dt className="info_title">{t('T30520')}</dt>
                  <dd className="info_text">{licensePlateNumber}</dd>
                </div>
              </dl>
            </div>
            <div className="notice_box">
              <p className="desc">
                <span className="ic ic_caution_16px"></span>
                {`${t('T30521')} (${authFailCount}/${MAX_FAIL_COUNT})`}
              </p>
            </div>
          </div>

          <div className="bottom_sheet_footer">
            <button
              type="button"
              className="btn btn_large btn_filled"
              onClick={() => window.bottomSheetClose(null)}
            >
              {t('T30154')}
            </button>
          </div>
        </div>
      </div>
    </BottomSheetWebViewWrapper>
  );
}

export default OwnerAuthenticationFailureBottomSheetPage;
